/**
 * At-Bat Log API Service
 *
 * The prospect's at-bat log — structured child records surfaced in the notes tab.
 */

import { del, get, post, put } from './api';
import type {
  AtBat,
  AtBatLog,
  CreateAtBatRequest,
  UpdateAtBatRequest,
} from '../types/at-bats';

const basePath = (prospectId: string) => `/api/prospects/${prospectId}/at-bats`;

export interface GetAtBatLogParams {
  pageNumber?: number;
  pageSize?: number;
}

/**
 * Fetch a page of the log, newest game first, plus a summary computed over the
 * prospect's entire log (not the page).
 */
export const getAtBatLog = (
  prospectId: string,
  { pageNumber = 1, pageSize = 100 }: GetAtBatLogParams = {},
): Promise<AtBatLog> => {
  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
  });
  return get<AtBatLog>(`${basePath(prospectId)}?${query.toString()}`);
};

export const createAtBat = (
  prospectId: string,
  request: CreateAtBatRequest,
): Promise<AtBat> => post<AtBat>(basePath(prospectId), request);

export const updateAtBat = (
  prospectId: string,
  atBatId: string,
  request: UpdateAtBatRequest,
): Promise<AtBat> => put<AtBat>(`${basePath(prospectId)}/${atBatId}`, request);

export const deleteAtBat = (prospectId: string, atBatId: string): Promise<void> =>
  del<void>(`${basePath(prospectId)}/${atBatId}`);
